/**
 * Upload a file to DigitalOcean Spaces via the dev-server proxy.
 * In development, files are sent to /api/upload (handled by setupProxy.js).
 * This avoids browser CORS issues entirely.
 *
 * @param {File|Blob} file The file to upload
 * @param {string} key  The destination path/key in the bucket
 * @returns {Promise<string>} The public URL of the uploaded file
 */
export const uploadFile = async (file, key) => {
  console.log(`--- uploadFile start: ${key}`, file);

  const formData = new FormData();
  formData.append('file', file);
  formData.append('key', key);

  const response = await fetch('/api/upload', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: response.statusText }));
    console.error(`--- uploadFile ERROR: ${key}`, err);
    throw new Error(err.error || 'Upload failed');
  }

  const data = await response.json();
  console.log(`--- uploadFile success: ${key} -> ${data.url}`);
  return data.url;
};
